/**
 *
 *
 * Author:   shann
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/3/18      1.0     First version
 *
 * Copyright  2021/3/18 , all rights reserved. Essa.cn
 * */
import axios from "axios";
import Cookie from "./cookie";
import Auth from "./auth";
import { message } from "antd";
import "nprogress/nprogress.css";
import NProgress from "nprogress";
import Lang from "../components/Lang/Lang";
import Locale from "./locale";

let hasMessage = false;

// 创建实例
let service = axios.create({
    // baseURL: process.env.NODE_ENV === "development" ? "/api" : "",
    baseURL:"",
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
    transformRequest: [
        function (data = {}, headers) {
            let extra = Cookie.getJSON("fmg.extra");
            if (extra) {
                // 实时获取当前浏览器的语言设定
                extra.lang = Locale.current();
                extra.businessPlatform = 'essaone';
                data["extra"] = extra;
            }
            return JSON.stringify(data);
        },
    ],
    transformResponse: [
        function (data) {
            data = JSON.parse(data);
            if (data.extra) {
                window.setUserName&&window.setUserName(data.extra.userName);
            }
            return data;
        },
    ],
});

service.interceptors.request.use(
    function (config) {
        NProgress.start();
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    function (response) {
        // 进度条
        NProgress.done();
        // 对响应数据做点什么
        let { data } = response;
        if (data.resultCode === "1006ER1000011") {
            if (hasMessage === false) {
                hasMessage = true;
                message
                    .error(
                        Lang({ id: "ZhangHuYiTingYong", default: "账户已停用" })
                    )
                    .then(() => {
                        Auth.logout();
                        hasMessage = false;
                        window.location.href = "/login";
                    });
            }
            return new Promise(() => {}); // 结束Promise链，不执行后面的then或catch
        } else if (data.resultCode === "2021R0005") { // 被修改菜单权限，踢出登录
            message
                .error(
                    Lang({ id: "NinDeQuanXianYiBeiXiuGaiQingChongXinDengLu", default: "您的权限已被修改，请重新登录" })
                )
                .then(() => {
                    Auth.logout();
                    window.location.href = "/login";
                });

            return new Promise(() => {}); // 结束Promise链，不执行后面的then或catch
        }
        return response;
    },

    function (error) {
        NProgress.done();
        return Promise.reject(error);
    }
);

service.all = axios.all;
service.spread = axios.spread;

export default service;
